// eslint-disable-next-line
export default new (class ServiceModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.active = data.active || false;
    model.link = data.link || [];
    model.detail = data.detail || [];

    if (data.image?.image) {
      model.image = data.image.image[0]?.url || "";
    } else {
      model.image = "";
    }

    model.icon = data.icon || "";
    model.banner = data.Banner || "";
    model.content = data.content || [];
    model.service = data.service || [];

    return model;
  }
})();
